import { CheckboxComponent } from "csi/components/boolean/CheckboxComponent";
import { useFormStore, useStatefulFormField } from "csi/middleware/form/index";
import React, { FunctionComponent } from "react";
import { useComponentOverlayContext } from "../hooks";

const FormFieldBoolean: FunctionComponent = () => {
	const field = useStatefulFormField();
	const formStore = useFormStore();
	const isParentOverlay = useComponentOverlayContext();
	const {
		id,
		label,
		tooltip,
		transientInfo: {
			disabled,
			readOnly,
			required,
			value,
		},
	} = field;
	const [fieldInvalid, fieldMessage] = formStore?.getFieldError(id) || [false, ""];
	const handleCheckboxChange = (checked: boolean): void => {
		formStore?.handleFieldChange(null, field, checked);
	};

	return (
		<CheckboxComponent
			aria-label={label}
			checked={!!value}
			dataCsiAutomation={id}
			disabled={readOnly || disabled}
			error={fieldInvalid}
			errorMessage={fieldMessage}
			label={label}
			onChange={handleCheckboxChange}
			required={required}
			tabIndex={isParentOverlay ? -1 : undefined}
			tooltip={tooltip}
		/>
	);
};

export default FormFieldBoolean;